// Animações dos apps (public/animacoes/<slugamigavel>.webm, 512x512 com fundo transparente),
// usadas no lugar do ícone e dos três pontinhos enquanto a IA procura a resposta.
// Para incluir um app: salvar o .webm com o slugamigavel do AppsArray e acrescentar em
// src/files/animacoes.json.
import ocupacoes from "../files/animacoes.json";

// Quanto do quadro do vídeo o logo ocupa (maior lado, em %, medido ao longo da animação), em
// src/files/animacoes.json, que a voz das landing pages também lê (api/_lib/animacoes.ts). Cada
// arquivo tem uma margem diferente em volta do logo: com isso o logo sai do mesmo tamanho do
// ícone parado das respostas. App fora da lista fica com o ícone e os pontinhos.
const OCUPACAO_DO_LOGO: Record<string, number> = ocupacoes;

// O Safari (e todo navegador no iPhone, que usa o motor dele) não mostra a transparência de
// vídeo WebM: a animação apareceria num quadrado preto. Nesses, ficam o ícone e os pontinhos.
const suportaWebmTransparente = () => {
  const ua = navigator.userAgent;
  const soWebkit = /AppleWebKit/.test(ua) && !/Chrome\/|Chromium\/|Edg\//.test(ua);
  return !soWebkit;
};

export const animacaoDoApp = (slugAmigavel?: string) =>
  slugAmigavel && slugAmigavel in OCUPACAO_DO_LOGO && suportaWebmTransparente()
    ? { src: `/animacoes/${slugAmigavel}.webm`, ocupacao: OCUPACAO_DO_LOGO[slugAmigavel] / 100 }
    : null;
